module.exports = __webpack_public_path__ + "static/media/pla_exc_che_val.0d9b6f6d.png";